
import React, { FC, useEffect, useRef, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initReactI18next, useTranslation } from "react-i18next";

const RecoveryPw = ({ dispatch_post_password }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const ref = useRef();
  const [t, i18n] = useTranslation();
  const [mail_address, set_mail_address] = useState("");

  useEffect(() => {}, []);
  return (
    <div class="d-flex flex-column justify-content-between bg-light vh-100">
      <header className="py-3 mb-auto bg-brand">
        <div className="container d-flex justify-content-between align-items-center">
          <a
            className="text-white"
            href="javascript:history.back();"
            onClick={(e) => {
              e.preventDefault();
              history.goBack();

              window.scroll(0, 0);
            }}
          >
            <i className="fas fa-angle-left fa-fw" />
            {t("戻る")}
          </a>
          <a
            href="index.html"
            onClick={(e) => {
              e.preventDefault();
              history.goBack();
              window.scroll(0, 0);
            }}
          >
            <img src="images/brand-white.svg" height={28} alt="SC WORLD EXCHANGE" />
          </a>
        </div>
      </header>
      <main role="main" className="main">
        <div className="container">
          <section className="login-section mx-auto mb-4">
            <div className="card">
              <div className="card-body">
                <form action="recovery-pw-verify.html" method="post">
                  <h1 className="h4 text-center font-weight-bold mb-4">
                    {t("パスワードのリセット")}
                  </h1>
                  <div className="form-group">
                    <label htmlFor="ml">{t("メールアドレス")}</label>
                    <input
                      type="email"
                      id="ml"
                      className="form-control"
                      placeholder={t("メールアドレスを入力してください")}
                      required
                      value={mail_address}
                      onChange={(e) => {
                        set_mail_address(e.target.value);
                      }}
                    />
                    {/* <small className="form-text text-muted">
                      Enter the email address that you used for the registration
                      of the personal account or at the SC WORLD EXCHANGE subscribe of
                      blog. We will send you an email with instructions.
                    </small> */}
                  </div>
                  <div className="form-group">
                    <button
                      className="btn btn-gradient-primary btn-block"
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch_post_password({ mail_address,type:2 }, () => {
                          history.push({
                            pathname: `/recovery-pwcode`,
                          });
                          window.scroll(0, 0);
                        });
                      }}
                    >
                      {t("パスワードのリセット")}
                    </button>
                  </div>
                  <hr />
                  <a
                    className="btn btn-outline-secondary btn-block"
                    href="signin.html"
                    onClick={(e) => {
                      e.preventDefault();
                      history.push({
                        pathname: `/signin`,
                      });
                      window.scroll(0, 0);
                    }}
                  >
                    {t("ログイン")}
                  </a>
                </form>
              </div>
            </div>
          </section>
        </div>
      </main>
      <footer className="mt-auto" />
    </div>
  );
};

export default RecoveryPw;
